import * as React from 'react';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface IObserverComponentProps {
  children?: Observable<any>;
  nullOnUnsubscribe?: boolean
}

interface IObserverComponentState {
  value: any | null;
}

class ObserverComponent extends React.Component<IObserverComponentProps, IObserverComponentState> {
  private readonly onUnmount: Subject<void> = new Subject<void>();

  constructor(props: IObserverComponentProps) {
    super(props);

    this.state = {value: null};
  }

  public componentDidMount() {
    if (this.props.children) {
      this.startSubscription(this.props.children);
    }
  }

  public componentWillReceiveProps(nextProps: Readonly<IObserverComponentProps>) {
    this.onUnmount.next();

    if (this.props.nullOnUnsubscribe) {
      this.setState({value: null});
    }

    if (nextProps.children) {
      this.startSubscription(nextProps.children);
    }
  }

  public componentWillUnmount() {
    this.onUnmount.next();
  }

  public render() {
    return this.state.value;
  }

  private startSubscription(observable: Observable<any>) {
    observable
      .pipe(takeUntil(this.onUnmount))
      .subscribe(v => this.setState({value: v}));
  }
}

export default ObserverComponent;



// WEBPACK FOOTER //
// ./src/components/observer_component.tsx